import {writable} from 'svelte/store';

let localsObject = {
    list: null,
    total: 0,
    selectedId: null,
    statusId: '', // due to Svelte bug on select control!!
    page: 1,

    search: {
        transfer_from: null,
        transfer_to: null,
        status_id: '',
        type_id: '',
        driver_id: null,
        location_id: null,
        department_id: null,
        offset: 0,
        limit: null,
        sort_field: null,
        sort_way: null,
    },

    driver: null,
    location: null,
    department: null,
    changed: false,
    notifications: true,
    scrollY: null,
};

const {get, set, update, subscribe} = writable(localsObject);

const localTransfers = {
    set,
    update,
    subscribe,

    clearSearch: () => {
        localTransfers.update(obj => {
            obj.statusId = '';
            obj.driver = null;
            obj.location = null;
            obj.department = null;

            obj.search.status_id = '';
            obj.search.type_id = '';
            obj.search.driver_id = null;
            obj.search.location_id = null;
            obj.search.department_id = null;
            obj.search.offset = 0;

            obj.page = 1;
            return obj;
        });
    }
}

export default localTransfers;